export default function ProfileSkeleton() {
  return (
    <div className="flex flex-col gap-5">
      {/* Header card */}
      <div className="card-base overflow-hidden">
        {/* Cover */}
        <div className="h-28 skeleton rounded-none" />
        <div className="px-5 pb-5">
          <div className="flex items-end justify-between -mt-10 mb-4">
            <div className="skeleton w-20 h-20 rounded-2xl" />
            <div className="flex gap-2 pb-1">
              <div className="skeleton h-9 w-24 rounded-lg" />
              <div className="skeleton h-9 w-9 rounded-lg" />
            </div>
          </div>
          <div className="skeleton h-6 w-40 rounded mb-2" />
          <div className="skeleton h-4 w-24 rounded mb-4" />
          <div className="skeleton h-4 w-3/4 rounded mb-1" />
          <div className="skeleton h-4 w-1/2 rounded mb-5" />
          <div className="grid grid-cols-6 gap-2">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="skeleton h-16 rounded-xl" />
            ))}
          </div>
        </div>
      </div>

      {/* Performance charts */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="card-base p-5">
          <div className="skeleton h-5 w-32 rounded mb-4" />
          <div className="skeleton h-40 rounded-xl" />
        </div>
        <div className="card-base p-5">
          <div className="skeleton h-5 w-32 rounded mb-4" />
          <div className="skeleton h-40 rounded-xl" />
        </div>
      </div>

      {/* Tabs */}
      <div className="card-base overflow-hidden">
        <div className="flex gap-1 p-2 border-b" style={{ borderColor: 'var(--border)' }}>
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="skeleton h-9 w-20 rounded-lg" />
          ))}
        </div>
        <div className="p-4">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="skeleton rounded-xl" style={{ aspectRatio: '4/3' }} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
